import { typography } from '../vars';

const typeface = (face: keyof typeof typography) => `
    ${(typography as any)[face]()}
`;

export { typeface };
